const baseCategories = [
    {
        title: "News",
        fullTitle: "News",
        path: "news",
        liveCategory: "News/Live",
        baseNavSection: "news",
    },
    {
        title: "Sports",
        fullTitle: "Sports",
        path: "sports",
        liveCategory: "Sports/Live",
        baseNavSection: "sports",
    },
    {
        title: "Arts",
        fullTitle: "Shows/Shows/CBC Arts",
        path: "arts",
        liveCategory: null,
        baseNavSection: "arts",
    },
    {
        title: "Life",
        fullTitle: "Shows/Shows/CBC Life",
        path: "life",
        liveCategory: null,
        baseNavSection: "life",
    },
    {
        title: "Archives",
        fullTitle: "Digital Archives",
        path: "archives",
        liveCategory: null,
        baseNavSection: "archives",
    },
    {
        title: "Music",
        fullTitle: "Music",
        path: "music",
        liveCategory: null,
        baseNavSection: "music",
    },
    {
        title: "Docs",
        fullTitle: "Docs",
        path: "docs",
        liveCategory: null,
        baseNavSection: "documentaries",
    },
];

const getBaseCategoryByFullTitle = (fullTitle) => {
    return (
        baseCategories.find((item) => {
            return (
                fullTitle
                    .toLowerCase()
                    .indexOf(item.fullTitle.toLowerCase()) === 0
            );
        }) || {}
    );
};

/**
 *
 * Receives an array of categories (clip.categories)
 * This function will iterate over baseCategories array and
 * return the first base category that was found in clip.categories
 *
 * IMPORTANT: This function demonstrates why the order of categories
 * in baseCategories mapping is essential!
 */

export const getBaseCategoryByMediaItemCategories = (categories = []) => {
    let baseCategory;

    if (categories.length > 0) {
        baseCategory = baseCategories.find((baseCat) =>
            categories.find((category) => {
                return category.name
                    .toLocaleLowerCase()
                    .startsWith(baseCat.fullTitle.toLocaleLowerCase());
            })
        );

        if (baseCategory && Object.keys(baseCategory).length === 0) return;
    }

    return baseCategory;
};

export const getPathByFullTitle = (fullTitle) => {
    if (!fullTitle || typeof fullTitle !== "string") return null;

    let baseCategory = getBaseCategoryByFullTitle(fullTitle);

    if (Object.keys(baseCategory).length === 0) return null;

    let path = fullTitle
        .toLowerCase()
        .replace(baseCategory.fullTitle.toLowerCase(), baseCategory.path);

    return path.toLowerCase();
};
